import * as React from 'react';
import {classify} from 'src/utils/classify';
import {useSelector} from 'react-redux';
import css from 'src/designSystem2021Components/banner/banner-card/banner-card.css';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  BodyMedium,
  ButtonTextMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';


export type BannerCardProps = {
  warningType: string;
  bannerText: string;
  showResolveButton: boolean;
  handleResolve: () => Promise<void>;
  handleClose: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export const BannerCard = ({
  warningType,
  bannerText,
  showResolveButton,
  handleResolve,
  handleClose,
  onMouseEnter,
  onMouseLeave,
}: BannerCardProps) => {
  const contentWarningTextType = useSelector(
    // @ts-expect-error - TS2339 - Property 'messages' does not exist on type 'DefaultRootState'.
    (state) => state.messages.contentWarningTextType,
  );
  const contentWarningTextValue = useSelector(
    // @ts-expect-error - TS2339 - Property 'messages' does not exist on type 'DefaultRootState'.
    (state) => state.messages.contentWarningTextValue,
  );

  return (
    <div
      className={classify(css.bannerCardContainer, {
        [css.hover]:
          contentWarningTextType === warningType && contentWarningTextValue,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      // @ts-expect-error - TS2322 - Type '{ children: Element[]; className: string; onMouseEnter: () => void; onMouseLeave: () => void; warningType: string; }' is not assignable to type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.
      warningType={warningType}
    >
      <InContextAlert
        leftIconName="circle-exclamation"
        onAction={handleResolve}
        semantic="warning"
        actionText={showResolveButton ? 'Resolve' : ''}
        dismissable
        onCloseClick={handleClose}
      >
        {bannerText}
      </InContextAlert>
    </div>
  );
};
